/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Add_User_DescriptionInputs */



/**
* | output |
* | --- |
* | "Grant individual user access to this space with specific permissions." |
*
* @param {Spaces_Add_User_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_add_user_description = /** @type {((inputs?: Spaces_Add_User_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Add_User_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gewähre einem einzelnen Benutzer Zugriff auf diesen Space mit bestimmten Berechtigungen.")
	return /** @type {LocalizedString} */ ("Grant individual user access to this space with specific permissions.")
});